import type {Data, GroupedParts, SeparatedParts} from 'schemaDefinition/types';

export const getGroupedParts = (
  separatedParts: SeparatedParts<Data, Data>,
  mode: 'form' | 'preview',
): GroupedParts<Data, Data>[] => {
  let group: GroupedParts<Data, Data> = {parts: []};
  const grouped: GroupedParts<Data, Data>[] = [];
  separatedParts.forEach(p => {
    // Include proper parts (not separators) and line-separators
    if (Array.isArray(p) || p.type !== 'separator' || p[mode] === 'line') {
      group.parts.push(p);
    }
    // Handle card-separator, ignore 'none'
    else if (p[mode] === 'card') {
      if (group.parts.length > 0) {
        grouped.push(group);
      }
      group = {titleKey: p.titleKey, role: p.role, parts: []};
    }
  });
  if (group.parts.length > 0) {
    grouped.push(group);
  }

  return grouped;
};
